@if (faIcon) {
  <app-icon
    [faIcon]="faIcon"
    [bgColor]="iconBgColor">
  </app-icon>
}
<div class="title-content font-bold"
     [class.title-center]="center">
  <ng-content></ng-content>
</div>
